<template>
  <ItemPage
    title="Tags"
    size="sm"
    :actions="actions"
  >
    <template v-if="tagTypesView">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquise pelo nome da tag"
        single-line
        hide-details
      />
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            :search="search"
            item-key="id"
            @click:row="editTagType($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import DialogAddTag from '@/pages/tags/DialogAddTag.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      loading: false,
      loadingMsg: '',
      dialogAddTag: false,
      renderComponent: 0,
      contents: [],
      search: '',
      errortag: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Tag',
          action: this.openDialogAddTag,
          icon: 'mdi-plus',
          disabled: !this.tagTypesCreate
        }
      ]
    },
    tagTypesView () {
      return utils.checkPermissions('tags.view-any')
    },
    tagTypesCreate () {
      return utils.checkPermissions('tags.create')
    }
  },
  async created () {
    await this.getTags()
  },
  methods: {
    async getTags () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getTags()
        this.contents = content
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao obter tags.', color: 'red' })
      }
      this.loading = false
    },
    editTagType (event) {
      this.$router.push({ name: 'tags.id', params: { id: event.id } })
    },
    async openDialogAddTag () {
      this.$dialog.custom(DialogAddTag).show()
        .then(async (tagType) => {
          if (!tagType) {
            return
          }
          try {
            await this.$api.newTag(tagType)
            this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso' })
            this.getTags()
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar salvar', color: 'red' })
          }
          this.loading = false
        })
    }
  }
}
</script>
